// apps/web/src/App.tsx
// Main application component with complete routing.

import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from './lib/auth.js';
import { router } from './routes/AppRoutes.js';
import './styles/index.css';

function App() {
  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  );
}

export default App;